import React from 'react';
import PropTypes from 'prop-types';

import Definition from '../../../shared/Definition';

const Breeder = ({ breederName, className, isWeatherbysMobile }) => {
    if (isWeatherbysMobile) {
        return (
            breederName ? (
                <Definition
                    term={isWeatherbysMobile ? breederName : 'Breeder'}
                    className={className}
                    forceShow
                    isTermLabel={false}
                    description=""
                />
            ) : null
        );
    }

    return (
        breederName ? (
            <Definition
                term="Breeder"
                className={className}
                description={breederName}
            />
        ) : null
    );
};

Breeder.propTypes = {
    breederName: PropTypes.string,
    className: PropTypes.string,
    isWeatherbysMobile: PropTypes.bool,
};

export default Breeder;



// WEBPACK FOOTER //
// ./src/js/horse/details/components/Breeder.jsx